import { createContext } from "react";

const initialState = {};
const StoreContext = createContext(initialState);

export default StoreContext;
